module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('video', {
    ref: "player",
    class: {
      'zoom': _vm.videoAspectRatio.modes[_vm.videoAspectRatio.index] === 'zoom', 'ratio-4-3': _vm.videoAspectRatio.modes[_vm.videoAspectRatio.index] === '4:3', 'ratio-16-9': _vm.videoAspectRatio.modes[_vm.videoAspectRatio.index] === '16:9'
    },
    attrs: {
      "id": "vjs_video_3_html5_api",
      "src": "",
      "playsinline": "true",
      "webkit-playsinline": "true",
      "preload": "auto",
      "autoplay": ""
    },
    domProps: {
      "muted": _vm.src ? '' : 'muted'
    }
  }), _vm._v(" "), _c('debug', {
    ref: "debug",
    attrs: {
      "hls": _vm.hls
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e5cfdd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 92
// module chunks = 0